// extracted by mini-css-extract-plugin
module.exports = {"otc-grid":"productGrid_otc-grid__q3IpL"};